import * as path from 'shared/path';

import { undefinedNullOrEmpty } from 'common/functions/string';

import { LooklessControl } from 'runtime/controls/looklesscontrol';
import { ControlArgs } from 'runtime/controls/controlargs';
import { registerBinding } from 'runtime/bindingengine';
import { ActivityExecutionRequested } from 'runtime/events/activityexecutionrequested';
import { ActivityUpdate } from 'runtime/data/activityupdate';

const defaultFilename = 'export.csv';

export class DownloadControl extends LooklessControl {
    private activityName: string;
    private fileName: string;

    constructor(args: ControlArgs) {
        super(args);

        this.methods.register(this.config.elementName, this);

        this.filename(this.config.filename);
        this['content.ActivityName'](this.config['content.ActivityName']);

        this.subscriptions = this.processBindings(this.config);
    }

    download() {
        var callback = (r: ActivityUpdate) => window.location.href = path.downloadActivityResult(
            this.fileName,
            r.results.filter(x => x.name === 'Content' && x.retained)[0].value
        );

        this.eventAggregator.publish(new ActivityExecutionRequested(this.activityName, this.fieldContext, null, callback, ['Content']));
    }

    filename(value: string) {
        this.fileName = !undefinedNullOrEmpty(value) ? value
            : !undefinedNullOrEmpty(this.config.filename) ? this.config.filename
            : defaultFilename;
    }

    'content.ActivityName'(value: string) {
        this.activityName = !undefinedNullOrEmpty(value) ? value : this.config['content.ActivityName'];
    }
}

registerBinding('downloadcontrol', DownloadControl);